export default __webpack_public_path__ + "static/media/iop.3f51329f.png";